import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { BlockOrg } from "../../../../RoleChecker";

export default function ProjectBenefis({
  showBenefisModal,
  benefisData = [],
  removeBenefis,
  saveBenefis,
}) {
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      footer: "Total Penerima Manfaat: ",
    },
    {
      dataField: "benefis_category.name",
      text: "Kategori",
      sort: true,
      footer: "",
    },
    {
      dataField: "type",
      text: "Tipe",
      sort: true,
      footer: "",
    },
    {
      dataField: "qty",
      text: "Jumlah",
      sort: true,
      footer: (cell, row) => {
        const sum = cell.reduce((prev, curr) => prev + curr, 0);
        return sum;
      },
    },
    {
      formatExtraData: {
        blockOrg: BlockOrg(),
      },
      formatter: (cell, row, index, { blockOrg }) => {
        return (
          <>
            {blockOrg && (
              <OverlayTrigger
                overlay={
                  <Tooltip id="products-delete-tooltip">Hapus Benefis</Tooltip>
                }
              >
                <a
                  className="btn btn-icon btn-light btn-hover-danger btn-sm"
                  onClick={() => removeBenefis(row.uuid)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-danger">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
          </>
        );
      },
      footer: "",
    },
  ];

  return (
    <>
      <Card>
        <CardHeader title="Penerima Manfaat">
          <CardHeaderToolbar>
            {BlockOrg() && (
              <button className="btn btn-primary" onClick={showBenefisModal}>
                Tambah Penerima
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            remote
            keyField="uuid"
            data={benefisData}
            columns={columns}
          />
        </CardBody>
        <CardFooter>
          {BlockOrg() && (
            <button
              className="btn btn-success float-right"
              onClick={saveBenefis}
            >
              Simpan
            </button>
          )}
        </CardFooter>
      </Card>
    </>
  );
}
